import type { ListMessagesResponse } from '../services/dmMessages';

// The last DM thread per patient, kept 5 minutes so a reload shows it at once while it refreshes.
// sessionStorage, not localStorage: it is patient data, dropped when the tab closes.
export const DM_MESSAGES_CACHE_TTL_MS = 5 * 60 * 1000;
const KEY_PREFIX = 'odo:dm-messages:';

interface CachedThread {
    at: number;
    data: ListMessagesResponse;
}

function keyFor(patientId: string): string {
    return `${KEY_PREFIX}${patientId}`;
}

export function readCachedDmMessages(
    patientId: string,
    now: number = Date.now()
): CachedThread | undefined {
    try {
        const raw = sessionStorage.getItem(keyFor(patientId));
        if (!raw) return undefined;
        const cached = JSON.parse(raw) as CachedThread;
        if (typeof cached?.at !== 'number' || !Array.isArray(cached.data?.messages)) {
            return undefined;
        }
        return now - cached.at < DM_MESSAGES_CACHE_TTL_MS ? cached : undefined;
    } catch {
        return undefined;
    }
}

export function writeCachedDmMessages(
    patientId: string,
    data: ListMessagesResponse,
    now: number = Date.now()
): void {
    try {
        sessionStorage.setItem(keyFor(patientId), JSON.stringify({ at: now, data }));
    } catch {
        // Storage full or blocked: the in-memory query cache still works.
    }
}
